<template>
  <li class="sheet-item cart">
    <div class="chk-wrap">
      <input type="checkbox" name="" :id="'item-' + item.id" class="chk-hidden" :checked="isSelected" @change="$emit('toggle-select', item.id)" />
      <label :for="'item-' + item.id" class="inp-check"></label>
    </div>
    <div class="item-link-wrap">
      <NuxtLink to="javascript:void(0);" @click="handleClick" class="item-link">
        <div class="thumb-wrap" :class="{ 'sold-out': item.isSoldOut }">
          <img :src="item.thumb" :alt="item.alt">
        </div>
        <div class="item-info-wrap">
          <span v-if="item.badge" class="badge bulk">{{ item.badge }}</span>
          <span class="company">{{ item.company }}</span>
          <p class="item-name txt-multi-hide row2">{{ item.name }}</p>
          <ul class="option">
            <li>{{ item.validity }}</li>
            <li class="pay-li">
              결제 가능 수단
              <div class="pay-box">
                <button type="button" class="pay-btn">
                  <span class="h-coin" :class="{ on: item.payments.hcoin}"></span>
                  <span class="p-coin" :class="{ on: item.payments.pcoin}"></span>
                  <span class="credit-card" :class="{ on: item.payments.card}"></span>
                  <span class="account" :class="{ on: item.payments.account}"></span>
                </button>
                <div class="tooltip">
                  <p :class="{all: isAllPayment}">{{ paymentTooltipText }}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </NuxtLink>
    </div>

    <div class="price-wrap">
      <span class="discount">{{ HconCommonUtils.format.expComma(item.discount) }}%</span>
      <p class="price">{{ HconCommonUtils.format.addWon(item.price) }}</p>
      <div v-if="item.originalPrice" class="total-price">{{ HconCommonUtils.format.addWon(item.originalPrice) }}</div>
    </div>

    <div class="purchase-btn-wrap">
      <button type="button" class="btn btn-outline md" :disabled="item.isSoldOut" @click="$emit('add-item', item.id)">견적담기</button>
      <button type="button" class="btn md" :disabled="item.isSoldOut" @click="$emit('buy-item', item.id)">바로구매</button>
    </div>
    <button type="button" class="btn-delete01" @click="$emit('delete-item', item.id)" aria-label="장바구니 상품 삭제"></button>
  </li>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import type { CartItemType } from '@/pages/pc/order/basket/index.vue'

import { ORDER_CODE } from "@/constants/hconMessageConstants";
import { usePopup } from '@/composables/hconUsePopup'

const props = defineProps({
  item: {
    type: Object as PropType<CartItemType>,
    required: true
  },
  isSelected: Boolean
})

const isAllPayment = computed(() => {
  return Object.values(props.item.payments).every(p => p === true)
})

const paymentTooltipText = computed(() => {
  if (isAllPayment.value) return "모든 결제수단으로 구매가 가능합니다."

  const availabel = []
  if (props.item.payments.hcoin) availabel.push("H캐시")
  if (props.item.payments.pcoin) availabel.push("적립금")
  if (props.item.payments.card) availabel.push("카드")
  if (props.item.payments.account) availabel.push("현금")

  return `이 상품은 ${availabel.join('·')}으로만 구매할 수 있습니다.`
})

// 팝업 준비
const { showAlert } = usePopup()

const handleClick = () => {
  
  // 품절 체크
  if(props.item.isSoldOut === true) {
    showAlert({
      title: '알림',
      message: ORDER_CODE.ALT_HCON_9067,
      confirmText: '확인'
    })
    return
  }

  // 상품 상세 이동
  navigateTo({ path : `/pc/product/detail/${props.item.dspGdsCd}`})
}

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/order-hcon.scss" as *;
</style>